import Service from "./service";

export default class LoginService extends Service {
  private static fetchWithTimeout(url, options, timeout = 30000) {
    // 30 seconds to timeout
    return Promise.race([
      fetch(url, options),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error("timeout")), timeout)
      ),
    ]);
  }

  private static login = async (auth: any, token: string) => {
    try {
      const response: any = await LoginService.fetchWithTimeout(
        `${Service.getAPI()}/auth/token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${auth}`,
            deviceid: token,
          },
          mode: "cors",
          body: JSON.stringify({ loginType: "matanativa" }),
        }
      );

      if (response.status === 200) {
        return Promise.resolve(response.json());
      } else {
        return Promise.reject(response.status);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  private static recover = async (params: any) => {
    try {
      const response = await fetch(`${Service.getAPI()}/auth/password/update`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify(params),
      });

      if (response.status === 200) {
        return Promise.resolve(response.json());
      } else {
        return Promise.reject(response.status);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  private static sendMailRecover = async (params: any) => {
    try {
      const response = await fetch(`${Service.getAPI()}/auth/password/token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${params}`,
        },
        mode: "cors",
        body: JSON.stringify(params),
      });

      if (response.status === 200) {
        return Promise.resolve(response.json());
      } else {
        return Promise.reject(response.status);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  private static create = async (params: any) => {
    const data = params.data;
    try {
      const response = await fetch(`${Service.getAPI()}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify(data),
      });
      if (response.status === 201) {
        return Promise.resolve(response.json());
      } else {
        return Promise.reject(401);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  private static addMarketingLead = async (params: any) => {
    const data = params.data;
    try {
      const response = await fetch(
        `${Service.getAPI()}/marketing/conversions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          body: JSON.stringify(data),
        }
      );
      if (response.status === 200) {
        return Promise.resolve(response.json());
      } else {
        return Promise.reject(response.json());
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  static authenticate = async (token = Service.token()) => {
    try {
      const res = await fetch(`${Service.getAPI()}/users/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) return Promise.resolve(res.json());
      else return Promise.reject(res.status);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  static createUser = async (params: object) => {
    return await LoginService.create({ data: params });
  };

  static createNewLead = async (params: object) => {
    return await LoginService.addMarketingLead({ data: params });
  };

  /** Não colocar com utf8 aqui. Se alterar favor alterar tb para utf8 na API para funcionar. */
  static loginUser = async (login: string, pass: string, token: string) => {
    return await LoginService.login(window.btoa(login + ":" + pass), token);
  };

  static utf8ToB64 = (str) => {
    return window.btoa(unescape(encodeURIComponent(str)));
  };

  static resetPassword = async (payload) => {
    return await LoginService.recover({
      token: payload.token,
      password: LoginService.utf8ToB64(payload.password),
    });
  };

  static sendResetPasswordMail = async (payload) => {
    return await LoginService.sendMailRecover(payload);
  };
}
